@if (isFetching) {
  <div class="voice-guide-card">
    <div class="voice-guide-card__header">
      <figure>
        <ngx-skeleton-loader [theme]="{height: '100%', width: '100%'}"></ngx-skeleton-loader>
      </figure>
    </div>
    <div class="voice-guide-card__content">
      <h3 #titleRef>
        ‎<ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '70%'}"></ngx-skeleton-loader>
      </h3>

<!--      <div class="voice-guide-card__price">-->
<!--        ‎<ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '30%'}"></ngx-skeleton-loader>-->
<!--      </div>-->

      <div class="voice-guide-card__info" #spanRef>
        <ngx-skeleton-loader [theme]="{height: '16px', width: '70px', margin: '0'}"></ngx-skeleton-loader>
        <span class="divider"></span>
        <span><ngx-skeleton-loader [theme]="{height: '16px', width: '40px', margin: '0'}"></ngx-skeleton-loader>min</span>
        <span class="divider"></span>
        <span><ngx-skeleton-loader [theme]="{height: '16px', width: '40px', margin: '0'}"></ngx-skeleton-loader>km</span>
      </div>

    </div>
    <div class="voice-guide-card__footer">
      <button class="voice-guide-card__read-more btn-default btn-blue">
        Preview Tour
      </button>
    </div>
  </div>
} @else {
  @if (tour) {
    <div class="voice-guide-card">
      <div class="voice-guide-card__header">
        <figure>
          <img [src]="tour?.image | safeUrl" alt="country-image">
        </figure>
        <div class="voice-guide-card__header--free">
          Free with hotel reservation
        </div>
      </div>
      <div class="voice-guide-card__content">
        <h3>
          {{tour.title}}
        </h3>

<!--        <div class="voice-guide-card__price">-->
<!--          {{currencySettings.symbol}}{{currencySettings.symbol === '$' ? tour.price : tour.price_eur}}-->
<!--        </div>-->

        <div class="voice-guide-card__info">
          <span>{{itemSettings.type}}</span>
          <span class="divider"></span>
          <span>{{tour.time}}min</span>
          <span class="divider"></span>
          <span>{{distance}}km</span>
        </div>
      </div>
      <div class="voice-guide-card__footer">
        <button (click)="tourPreview($event)" class="btn-default voice-guide-card__preview">
          @if (!previewPlaying) {
            <img alt="play" class="player-icon with-margin" src="assets/svg/ic-speaker.svg">
          } @else {
            <img alt="pause" class="player-icon with-margin" src="assets/svg/ic-pause-audio.svg">
          }
          {{previewPlaying ? 'Stop' : 'Preview'}}
        </button>
        <a class="btn-default voice-guide-card__read-more" target="_blank" [href]="tour.url | safeUrl" (click)="setGoogleAnalytic()">
          Learn more
        </a>
      </div>
    </div>
  }
}
